import GetRequest from '../basic';

const getPMCommunityDetail = (callback: Function) => {
    GetRequest('getpcommunitydetail', {}, callback);
};

const getPMCommunityMotion = (callback: Function) => {
    GetRequest('getpcommunitytmotion', {}, callback);
};

export default null;
export {
    getPMCommunityDetail,
    getPMCommunityMotion
};